import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export default function AuthCallback() {
  const { hash, pathname } = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then((r) => { setUser(r.data); toast(`Signed in as ${r.data?.name || r.data?.email}`); })
      .catch(() => toast("Sign-in failed. Try again."))
      .finally(() => navigate(pathname, { replace: true }));
  }, [hash, pathname, navigate, setUser]);

  return <div className="min-h-screen" data-testid="auth-callback" />;
}
